module.exports = __webpack_public_path__ + "static/media/management_Andre_Gooden.aa3a5ace.jpg";